import {
  QuoteServiceTemplate,
  QuoteFreightTemplate,
  QuotePaymentTermTemplate,
  QuoteTermTemplate
} from '../quotetemplate';
import {
  IQuoteServiceTemplateData,
  IQuoteTemplate,
  IQuoteTemplateData,
  IQuoteTermTemplate,
  IQuoteTermTemplateData
} from '../quotetemplate.types';

export const mockQuoteTemplatesData = (): IQuoteTemplateData[] => [
  {
    id: 112,
    description:
      '<p>100% Advance Payment in U.S. Dollars to be received no less than Four (4) weeks prior</p>',
    title: 'Payment Terms:  Payment in Advance - U.S. Dollars'
  },
  {
    id: 2,
    title: 'Payment Terms:  Payment in Advance - U.S. Dollars',
    description:
      '<p>100% Advance Payment in U.S. Dollars to be received no less than Four (4) weeks prior</p>'
  },
  {
    id: 36,
    title: 'Payment Terms:  Payment in Advance - Canadian Dollars',
    description:
      '<p>100% Advance Payment in Canadian Dollars to be received no less than Four (4) weeks prior</p>'
  },
  {
    id: 18,
    title: 'Paragraph',
    description: '<p>Paragraph</p>'
  }
];

export const mockQuoteTermTemplatesData = (): IQuoteTermTemplateData[] => [
  {
    id: 112,
    description:
      '<p>100% Advance Payment in U.S. Dollars to be received no less than Four (4) weeks prior</p>',
    title: 'Payment Terms:  Payment in Advance - U.S. Dollars',
    organization: 0
  },
  {
    id: 2,
    title: 'Payment Terms:  Payment in Advance - U.S. Dollars',
    description:
      '<p>100% Advance Payment in U.S. Dollars to be received no less than Four (4) weeks prior</p>',
    organization: 1
  },
  {
    id: 36,
    title: 'Payment Terms:  Payment in Advance - Canadian Dollars',
    description:
      '<p>100% Advance Payment in Canadian Dollars to be received no less than Four (4) weeks prior</p>',
    organization: 1
  },
  {
    id: 18,
    title: 'Paragraph',
    description: '<p>Paragraph</p>',
    organization: 0
  }
];

export const mockQuoteServiceTemplatesData = (): IQuoteServiceTemplateData[] => [
  {
    id: 112,
    description:
      '<p>100% Advance Payment in U.S. Dollars to be received no less than Four (4) weeks prior</p>',
    title: 'Payment Terms:  Payment in Advance - U.S. Dollars',
    price_computations: [],
    days_computations: []
  },
  {
    id: 2,
    title: 'Payment Terms:  Payment in Advance - U.S. Dollars',
    description:
      '<p>100% Advance Payment in U.S. Dollars to be received no less than Four (4) weeks prior</p>',
    price_computations: [],
    days_computations: []
  },
  {
    id: 36,
    title: 'Payment Terms:  Payment in Advance - Canadian Dollars',
    description:
      '<p>100% Advance Payment in Canadian Dollars to be received no less than Four (4) weeks prior</p>',
    price_computations: [],
    days_computations: []
  }
];

export const mockQuoteServiceTemplateTranslationsData = (): IQuoteServiceTemplateData[] =>
  mockQuoteServiceTemplatesData();
export const mockQuoteTemplateTranslationsData = (): IQuoteTemplateData[] =>
  mockQuoteTemplatesData();

export const mockQuoteServiceTemplates = (): IQuoteTemplate[] =>
  mockQuoteServiceTemplatesData().map(
    template => new QuoteServiceTemplate(template)
  );
export const mockQuoteFreightTemplates = (): IQuoteTemplate[] =>
  mockQuoteTemplatesData().map(template => new QuoteFreightTemplate(template));
export const mockQuotePaymentTermTemplates = (): IQuoteTemplate[] =>
  mockQuoteTemplatesData().map(
    template => new QuotePaymentTermTemplate(template)
  );
export const mockQuoteTermTemplates = (): IQuoteTermTemplate[] =>
  mockQuoteTermTemplatesData().map(template => new QuoteTermTemplate(template));
